<template>
<div class="page-container">
  <el-breadcrumb separator="/">
    <el-breadcrumb-item>
      <span class="page-title">财务系统</span>
    </el-breadcrumb-item>
    <el-breadcrumb-item>平台账单查询</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card class="page-content" shadow="never">
    <div class="page-actions">
      <el-autocomplete
        class="inline-input"
        v-model="coinType"
        :fetch-suggestions="querySearch"
        placeholder="请输入币种">
        <i
          class="el-icon-close el-input__icon"
          slot="suffix"
          @click="cleanSearchCoin"
          style="cursor:pointer;">
        </i>
      </el-autocomplete>
      <el-date-picker
          type="datetimerange"
          value-format="timestamp"
          v-model="timeRange"
          start-placeholder="起始时间"
          end-placeholder="终止时间"
      >
      </el-date-picker>
      <el-button @click="handleSearchResult" type="primary">搜索</el-button>
      <el-button @click="handleSearchResultClear" type="">重置</el-button>
      <div class="preview-opration" style="float: right;;right: 0px; white-space:nowrap">
        <download-excel
            class="export-excel-wrapper"
            :data="this.getDetailsForm()"
            :fields="excelData.json_fields"
            :header="excelData.title"
            name="平台账单查询.xls"
            :before-generate="beforeGenerate"
        >
          <el-button type="success">导出</el-button>
        </download-excel>

      </div>
    </div>
    <div>
      <el-table
          class="coin-table"
          :data="addressList"
          :row-key="() => Math.random()"
          style="width: 100%"
      >
        <el-table-column label="币种" prop="coin" ></el-table-column>
        <el-table-column label="系统分发" prop="DEPOSIT_SYSTEM" width="100"></el-table-column>
        <el-table-column
            prop="DEPOSIT"
            label="区块链充值"
            width="150"
            :show-overflow-tooltip="true"
            >
          <template slot-scope="scope">
            <router-link :to= "{path: '/fundDetails/walletbill',query: {uid: scope.row.uid ,coinType: scope.row.coin,type:'txr'}}">
              <span style="color:#00a0e9;">{{scope.row.DEPOSIT}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="WITHDRAW"
            label="区块链提现"
            width="150"
            :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <router-link :to= "{path: '/fundDetails/walletbill',query: {uid: scope.row.uid ,coinType: scope.row.coin,type:'txr'}}">
              <span style="color:#00a0e9;">{{scope.row.WITHDRAW}}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="手续费" prop="FEE"></el-table-column>
        <el-table-column label="当前平台余额" prop="balance"></el-table-column>
        <el-table-column label="冻结" prop="freeze"></el-table-column>
        <el-table-column label="可用余额" prop="avBalance"></el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalCount" :page-size="indexPagination.size"
                     :current-page.sync="indexPagination.page" @current-change="handlePageChanged"/>
    </div>


  </el-card>
</div>


</template>
<pagination
    :size="pagination.size"
    :page="pagination.page"
    :total="totalCount"
    @pageChanged="handlePageChanged"
></pagination>

<script>
import './store';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';


export default {
  name: 'statisticsPlatform',
  data() {
    return {
      timeRange: [new Date().getTime()-24 * 90 * 60 * 60 * 1000,new Date().getTime()],
      indexPagination:{page:1,size:10},
      chain:"",
      coinType: '',
      address: '',
      memo: '',
      excelData:{
        title:"平台对账",
        json_fields:{
          "币种":{
            field:'coin',
            callback: value =>{
              return "&nbsp;" + value;
            }
          },
          "系统分发":'DEPOSIT_SYSTEM',
          "区块链充值":'DEPOSIT',
          "区块链提现":'WITHDRAW',
          "手续费":'FEE',
          "当前平台余额":'balance',
          "冻结":'freeze',
          "可用余额":'avBalance',
        }
      }
    };
  },
  computed: {
    ...mapState('statisticsPlatform', ['addressList', 'allCoins', 'pagination','totalCount'])
  },
  methods: {
    ...mapActions('statisticsPlatform', [
      'list',
      'getAllCoins',
       'clear'
    ]),
    handleSearchResult(data) {
      if (this.timeRange===null){
        this.$message("查询时间不能为空")
        return;
      }

      if (this.timeRange[0]>=this.timeRange[1]){
        this.$message('开始时间需小于等于截止时间');
        return;
      }


      if (this.timeRange[1]>new Date().getTime()){
        this.$message('截止时间 不能大于当前时间');
        return;
      }



      this.list({
        from: this.timeRange[0],
        to: this.timeRange[1],
        coinType: this.coinType,
        ...data.pagination
      });
    },
    handleSearchResultClear(data){
      this.timeRange=[new Date().getTime()-24 * 90 * 60 * 60 * 1000,new Date().getTime()];
      this.userId="";
      this.coinType="";
       this.clear();
    },
    handlePageChanged(currentPage){
      if (this.timeRange===null){
        alert("查询时间不能为空")
        return;
      }
      this.list({
        from: this.timeRange[0],
        to: this.timeRange[1],
        coinType: this.coinType,
        page:currentPage,
        size:10
      });
    },
    cleanSearchCoin() {
      this.coinType = '';
    },
    querySearch(queryString, cb) {
      var results = [];
      var coinList = this.allCoins;
      results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    querySearchChain(queryString, cb){
      var results = [];
      var coinList = ["BEP20","ERC20"];
      results = queryString ? coinList.filter(this.createFilter2(queryString)) : coinList;
      results = results.map((v, i, arr) => {
        return {
          value: v
        };
      });
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      let tempData = ["BEP20","ERC20"];
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    createFilter2(queryString) {
      let tempData = this.allCoins;
      return (tempData) => {
        return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(tab) {
        this.changeTab(tab.name);
    },
    refreshList(data = {}) {
      this.handleSearchResult(data);
    },
    getDetailsForm(){
      return this.addressList;
    },
    beforeGenerate(){
      if (this.getDetailsForm().length<1){
        alert("无数据导出")
      }
    }
  },
  created() {
    this.getAllCoins();
    this.handleSearchResultClear();
  }
};
</script>

<style lang="less" scoped>
</style>





